import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DynamicSearchDetailResponse,DynamicSearchObject } from '../../models/dynamic-pages';
import { CommonService } from '../services/common.service';
import { Title, Meta } from '@angular/platform-browser';

@Component({
    selector: 'app-dynamic-page',
    templateUrl: 'dynamic-page.component.html'
})

export class DynamicPageComponent implements OnInit {
    constructor(private _common:CommonService,private route: ActivatedRoute,private titleService: Title, private metaService: Meta) {
        
        this.route.queryParams.subscribe(queryParams => {
            // do something with the query params
            
        });
        this.route.params.subscribe(routeParams => {
            this.loadPageContent(routeParams.id);
        });
       // this.id = this.route.snapshot.paramMap.get('id');
      //  this.loadPageContent(this.id);
     }
    
    id:string;
    dynaicPageDetail:DynamicSearchObject;
    ngOnInit() { 
        
        // this.id = this.route.snapshot.paramMap.get('id');
        // this.loadPageContent(this.id);
      
    }

    loadPageContent(id:string){
        this._common.getDynamicPageDetail(id).subscribe((response:DynamicSearchDetailResponse) =>{
            if(response.status == true){
                
                this.dynaicPageDetail = response.data[0];     
                this.titleService.setTitle(this.dynaicPageDetail.metaTitle);
                this.metaService.addTags([
                  {name: 'keywords', content: this.dynaicPageDetail.metaKeywords},
                  {name: 'description', content: this.dynaicPageDetail.metaDescription},
                  {name: 'robots', content: 'index, follow'}
                ]);  
            }
           
        });
    }

}